var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.976,
    height: 20,
    viewBox: "0 0 17.976 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_28",
    "data-name": 28,
    transform: "translate(-3.415 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8443",
    "data-name": "Path 8443",
    d: "M21.022,16.755,19.8,15a1.428,1.428,0,0,1-.257-.814V9.142a7.142,7.142,0,0,0-14.283,0v5.042A1.428,1.428,0,0,1,5,15L3.783,16.755A1.428,1.428,0,0,0,4.84,19.14H8.9a3.571,3.571,0,0,0,7,0h4.064a1.428,1.428,0,0,0,1.057-2.385ZM12.4,20.568a2.142,2.142,0,0,1-2.014-1.428h4.028A2.142,2.142,0,0,1,12.4,20.568ZM4.84,17.711a.578.578,0,0,0,.086-.1l1.25-1.8a2.857,2.857,0,0,0,.514-1.628V9.142a5.713,5.713,0,0,1,11.427,0v5.042a2.857,2.857,0,0,0,.514,1.628l1.25,1.8a.579.579,0,0,0,.086.1Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.168647b114d0190922a119487817929c.svg";
export { ForwardRef as ReactComponent };